import { combineReducers } from 'redux';
import users from './users';
import subscription from './subscription';
import PreProcessMedicalRecords from './preProccessedMedicalRecords';
import fileUpload from './fileUpload';
import demandMap from './demandMap';

const rootReducer = combineReducers({
  users: users,
  subscription: subscription,
  preProcessMedicalRecords: PreProcessMedicalRecords,
  fileUpload: fileUpload,
  demandMap: demandMap,
});

export default rootReducer;